import { AlertCircle } from "lucide-react";
import { Container, IconContainer, Mensagem, BotaoRetry } from "./styles";

interface AbaErroProps {
    onRetry: () => void;
    mensagem?: string;
}

export default function AbaErro({ onRetry, mensagem = "Não foi possível carregar informações da demanda." }: AbaErroProps) {
    return (
        <Container>
            <IconContainer>
                <AlertCircle size={48} />
            </IconContainer>
            <Mensagem>{mensagem}</Mensagem>
            <BotaoRetry onClick={onRetry}>
                Tentar novamente
            </BotaoRetry>
        </Container>
    );
}


